import { render, staticRenderFns } from "./CardPlayerGoals.vue?vue&type=template&id=4bf50330"
import script from "./CardPlayerGoals.js?vue&type=script&lang=js&external"
export * from "./CardPlayerGoals.js?vue&type=script&lang=js&external"
import style0 from "./CardPlayerGoals.vue?vue&type=style&index=0&id=4bf50330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports